import { useNavigate as useNavigateRouter } from 'react-router-dom';
import { PAGES } from '@/pages/PAGE_CONSTANTS';
import useGetPageUrl from "@/routers/useGetPageUrl";

const useNavigateHook = useNavigateRouter;

export interface OnNavigateProps {
  pageName: PAGES;
  params?: { [key: string]: string };
  state?: { [key: string]: any };
  rawUrlPath?: string;
}

/**
 * Hook that returns a function to navigate to a page
 * The function will use the react-router-dom/ui-router navigate function
 * The function just need the page name and the params if the page has params
 * @example
 * const navigate = useNavigate();
 * navigate(PAGES.HOME);
 * @example
 * const navigate = useNavigate();
 * navigate(PAGES.PROCEDURE_DETAILS, {id: '123'}); // /procedure/:id -> /procedure/123
 * @return function
 */
const useNavigate = () => {
  const navigate = useNavigateHook();
  const getPageUrl = useGetPageUrl();

  const onNavigate = ({ pageName, params, state, rawUrlPath }: OnNavigateProps) => {
    let navigatePage: string | undefined = pageName;
    if (rawUrlPath) {
      navigate(rawUrlPath);
      return;
    }
    navigatePage = getPageUrl({ pageName, params });
    navigate(navigatePage, { state: state });
  };

  return onNavigate;
};

export default useNavigate;
